import { USER_LOGGED_ROUTES_PATH_PREFIX } from '~/constants'

export default defineNuxtRouteMiddleware(async (to) => {
  // Only apply middleware to routes with organisationId parameter and account path
  if (to.path.includes(USER_LOGGED_ROUTES_PATH_PREFIX)) {
    const { decodedToken } = useSession()
    const currentUser = decodedToken.value?.payload?.value
    const accountIdPage = Number(to.params.organisationId)

    if (!currentUser) {
      return abortNavigation()
    }
    if (
      currentUser.isAdmin
      || [
        ...currentUser.ownedByOrganisationsIds,
        ...currentUser.ownedOrganisationsIds,
        ...currentUser.organisationIds,
      ].includes(accountIdPage)
    ) {
      return true
    }
    console.error('Not allowed to reach account page', {
      currentUserId: currentUser.id,
      currentOrganisationId: currentUser.currentOrganisationId,
      accountIdPage,
    })
    return abortNavigation()
  }
})
